<template>
	<div class="full-container g-bg" v-lazy:background-image="'//doc.yctop.com/yc/static/2020-9-16/bg.jpg'">
		<div class="register">
			<div class="reg-cont">
				<div class="img-box">
					<router-link to="/">
						<img src="//doc.yctop.com/yc/static/2020-9-10/intrude-logo.png" alt="" class="yc-logo">
					</router-link>
				</div>
				<div class="reg-title">
					<p class="one">{{$t("user.welcome")}}</p>
					<p>{{$t("user.title")}}</p>
				</div>
				<div>
					<p class="reg-row">{{$t("user.nickname")}} <span class="point">*</span></p>
					<el-input v-model="username"></el-input>
				</div>
				<div class="reg-err">
					<span v-if="!!usernameErr">{{usernameErr}}</span>
				</div>
				<div>
					<p class="reg-row">{{$t("user.email")}} <span  class="point">*</span></p>
					<el-input v-model="email"></el-input>
				</div>
				<div class="reg-err">
					<span v-if="!!emailErr">{{emailErr}}</span>
				</div>
				<div>
					<p class="reg-row">{{$t("user.pw")}} <span class="point">*</span></p>
					<el-input v-model="origin" show-password></el-input>
				</div>
				<div class="reg-err">
					<span v-if="!!originErr">{{originErr}}</span>
				</div>
				<div>
					<p class="reg-row">{{$t("user.confirm")}}<span class="point">*</span></p>
					<el-input v-model="password" show-password></el-input>
				</div>
				<div class="reg-err">
					<span v-if="!!passwordErr">{{passwordErr}}</span>
				</div>
				<div>
					<p class="reg-row">{{$t("user.company")}} </p>
					<el-input v-model="orgName"></el-input>
				</div>
				<div v-if="!existSpread" class="spread-row">
					<p class="reg-row">{{$t("user.spread")}}</p>
					<el-input v-model="spread"></el-input>
				</div>
				<div class="reg-err">
					<span v-if="!!backError">{{backError}}</span>
				</div>
				<el-button type="primary" class="reg-btn" @click="signUp"  :loading="regLoading">{{$t("header.menu.register")}}</el-button>
				
				<div class="login-tips">
					{{$t("user.exist")}}
					<router-link to="/user/login">{{$t("header.menu.login")}}</router-link>
				</div>
			</div>
		</div>
		
	</div>
	
</template>

<script>
export default {
	data:function(){
		return {
			username:'',
			email:'',
			origin:'',
			password:'',
			orgName:'',
			spread:'',
			usernameErr:'',
			emailErr:'',
			originErr:'',
			passwordErr:'',
			existSpread:false,
			backError:'',
			regLoading:false,
		}
	},
	created: function(){
        !!this.$route.query.spread && (this.spread=this.$route.query.spread) && (this.existSpread=true)
    },
	methods:{
		signUp:function(){
			this.backError=''
			if(!this.verifyName()){
                return;
			}
			if(!this.verifyEmail()){
                return;
			}
			if(!this.verifyPW()){
                return;
			}
			if(!this.verifyAgain()){
                return;
			}
			this.regLoading=true
			let data = {
                nickname: this.username,
                email: this.email,
                origin: this.origin, 
                pw: this.password, 
                spread: this.spread,
                orgName: this.orgName,
            }, successFn = function() {
				_this.regLoading=false
                _this.$router.push('/');
            }, failFn = function(err) {
				_this.regLoading=false
				if(err.code=='3007'){
					_this.emailErr=err.message
				}else{
					_this.backError=err.message
				}
            }, _this = this
            _this.$store.dispatch('signUp', data).then(successFn, failFn)
		},
		verifyName: function() {
			if(this.username==''){
				this.usernameErr = 'Username Required'
				return false;
			}
			this.usernameErr = ''
			return true;
		},
		verifyEmail: function() {
			let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			if(this.email==''){
				this.emailErr = 'Email Required'
				return false;
			}else if(!reg.test(this.email)){
				this.emailErr = 'Email is invalid or already taken';
				return false;
			}
			this.emailErr = ''
			return true;
		},
		verifyPW: function() {
			if(this.origin==''){
				this.originErr = 'Password Required'
				return false;
			}
			this.originErr = ''
			return true;
		},
		verifyAgain: function() {
           if (this.password === "") {
                this.passwordErr = "Confirm password Required";
                return false;
            } else if (this.password !== this.origin) {
                this.passwordErr = "The two passwords entered are inconsistent!";
                return false;
            }
            this.passwordErr = '';
            return true;
        },
	}

};
</script>

<style scoped>
@import "~@/assets/css/view/user/signup.css";
</style>